// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_BalanceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /subaccounts/franchises/balance/{id}
 *
 * Returns the account balance from the upstream payment provider.
 * Source: PaymentProviderInterface::getBalance() — for ASAAS this is the
 * GET /finance/balance call (AsaasProvider::getBalance()), which returns a
 * single-field JSON object {"balance": <number>} (account balance in BRL).
 * The controller wraps the decoded provider array as the dados object, so the
 * wire shape is a single object with one float field.
 *
 * @see subaccounts/franchises.php::balance()
 * @see AsaasProvider::getBalance()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsFranchises_BalanceResponseDados {
balance: number
}

export type SubaccountsFranchises_BalanceResponse = ApiResponse<SubaccountsFranchises_BalanceResponseDados>;

registerResponseContract('SubaccountsFranchises_BalanceResponse', {
  balance: { type: 'number',  required: true },
})
